import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Converte cor HEX (#3b82f6) para formato HSL sem parênteses ("217 91% 60%")
 * que é o formato esperado pelas CSS variables do shadcn/ui.
 */
export function hexToHsl(hex: string): string {
  // Remover #
  const clean = hex.replace(/^#/, '');
  const r = parseInt(clean.substring(0, 2), 16) / 255;
  const g = parseInt(clean.substring(2, 4), 16) / 255;
  const b = parseInt(clean.substring(4, 6), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;

  if (max === min) {
    return `0 0% ${Math.round(l * 100)}%`;
  }

  const d = max - min;
  const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

  let h = 0;
  if (max === r) {
    h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
  } else if (max === g) {
    h = ((b - r) / d + 2) / 6;
  } else {
    h = ((r - g) / d + 4) / 6;
  }

  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

/**
 * Ajusta a lightness de uma cor HSL ("217 91% 60%") por um amount (+/- percentual).
 * Ex: adjustHslLightness("217 91% 60%", -8) → "217 91% 52%"
 */
export function adjustHslLightness(hsl: string, amount: number): string {
  const parts = hsl.match(/(\d+)\s+(\d+)%\s+(\d+)%/);
  if (!parts) return hsl;

  const h = parts[1];
  const s = parts[2];
  const l = Math.max(0, Math.min(100, parseInt(parts[3], 10) + amount));

  return `${h} ${s}% ${l}%`;
}
